<template>
  <div style="width:181px;">
    <v-list dense>
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        ripple
        link
        @click="applySelection(item.value)"
      >
        <v-icon
          :color="item.color"
          size="14"
        >
          $faCircle
        </v-icon>
        <span class="pl-2">
          {{ item.label }}
        </span>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'StatusFilter',
    props: {
      items: {
        type: Array,
        validator: arr => arr.every(item => !!item.color && !!item.label),
      },
    },
    methods: {
      applySelection (status) {
        const payload = { key: 'status', operator: '=', value: status }
        this.$emit('select-status', payload)
        // Force closes menu after selection
        this.$parent.$parent.save()
      },
    },
  }
</script>
